import { deviceDetect } from 'react-device-detect'
import config from '../config'

const shouldRunAnalytics = !config.isDev

const options = {
  integrations: {
    All: true,
    Slack: false,
  },
}

class AnalyticsHelper {
  getDeviceType = () => deviceDetect()
  getTimestamp = () => new Date().toISOString()

  segmentTrack = (trackEventName, trackData = {}) => {
    if (shouldRunAnalytics) {
      const updatedTrackData = {
        ...trackData,
        userAgent: this.getDeviceType(),
        ...(localStorage.userId
          ? { userId: localStorage.userId }
          : { anonymousId: window.localStorage.getItem('ajs_anonymous_id') }),
        email: localStorage.email || trackData.email,
        path: window.location.pathname,
        timestamp: this.getTimestamp(),
      }

      window.analytics.track(trackEventName, updatedTrackData, options)
    }
  }

  segmentAddPage = (pageName, category = 'Dashboard') => {
    if (shouldRunAnalytics) {
      window.analytics.page(
        category,
        pageName,
        {
          userId: localStorage.userId,
          email: localStorage.email,
          timestamp: this.getTimestamp(),
        },
        options
      )
    }
  }

  segmentIdentifyAndGroup = user => {
    if (shouldRunAnalytics) {
      const isHost = !!user.Host
      window.analytics.identify(
        user.id,
        {
          user_id: user.id,
          orientation: user.sexualOrientation,
          name: user.name,
          isHost,
          birthdate: user.birthdate,
          gender: user.gender,
          preference: user.preference,
          email: user.email,
          location: user.location,
          phoneNumber: user.phoneNumber,
          profileImage: user.profileImage,
          timestamp: this.getTimestamp(),
        },
        options
      )
      window.analytics.group(isHost ? 'matchmaker' : 'dater')
    }
  }
}

const analytics = new AnalyticsHelper()

const trackEventViewed = (event, context) => {
  if (event) {
    analytics.segmentTrack('Event Viewed', {
      context,
      event_id: event.id,
      event_name: event.title,
    })
  }
}

export default analytics
export { trackEventViewed }
